//foundation 6 init
jQuery(document).foundation();

/*!
 * JavaScript Cookie v2.2.0
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
    var registeredInModuleLoader = false;
    if (typeof define === 'function' && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    if (typeof exports === 'object') {
        module.exports = factory();
        registeredInModuleLoader = true;
    }
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function () {
            window.Cookies = OldCookies;
            return api;
        };
    }
}(function () {
    function extend () {
        var i = 0;
        var result = {};
        for (; i < arguments.length; i++) {
            var attributes = arguments[ i ];
            for (var key in attributes) {
                result[key] = attributes[key];
            }
        }
        return result;
    }

    function init (converter) {
        function api (key, value, attributes) {
            var result;
            if (typeof document === 'undefined') {
                return;
            }

            // Write

            if (arguments.length > 1) {
                attributes = extend({
                    path: '/'
                }, api.defaults, attributes);

                if (typeof attributes.expires === 'number') {
                    var expires = new Date();
                    expires.setMilliseconds(expires.getMilliseconds() + attributes.expires * 864e+5);
                    attributes.expires = expires;
                }

                // We're using "expires" because "max-age" is not supported by IE
                attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

                try {
                    result = JSON.stringify(value);
                    if (/^[\{\[]/.test(result)) {
                        value = result;
                    }
                } catch (e) {}

                if (!converter.write) {
                    value = encodeURIComponent(String(value))
                        .replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
                } else {
                    value = converter.write(value, key);
                }

                key = encodeURIComponent(String(key));
                key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
                key = key.replace(/[\(\)]/g, escape);

                var stringifiedAttributes = '';

                for (var attributeName in attributes) {
                    if (!attributes[attributeName]) {
                        continue;
                    }
                    stringifiedAttributes += '; ' + attributeName;
                    if (attributes[attributeName] === true) {
                        continue;
                    }
                    stringifiedAttributes += '=' + attributes[attributeName];
                }
                return (document.cookie = key + '=' + value + stringifiedAttributes);
            }

            // Read

            if (!key) {
                result = {};
            }

            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling "get()"
            var cookies = document.cookie ? document.cookie.split('; ') : [];
            var rdecode = /(%[0-9A-Z]{2})+/g;
            var i = 0;

            for (; i < cookies.length; i++) {
                var parts = cookies[i].split('=');
                var cookie = parts.slice(1).join('=');

                if (!this.json && cookie.charAt(0) === '"') {
                    cookie = cookie.slice(1, -1);
                }

                try {
                    var name = parts[0].replace(rdecode, decodeURIComponent);
                    cookie = converter.read ?
                        converter.read(cookie, name) : converter(cookie, name) ||
                        cookie.replace(rdecode, decodeURIComponent);

                    if (this.json) {
                        try {
                            cookie = JSON.parse(cookie);
                        } catch (e) {}
                    }

                    if (key === name) {
                        result = cookie;
                        break;
                    }

                    if (!key) {
                        result[name] = cookie;
                    }
                } catch (e) {}
            }

            return result;
        }

        api.set = api;
        api.get = function (key) {
            return api.call(api, key);
        };
        api.getJSON = function () {
            return api.apply({
                json: true
            }, [].slice.call(arguments));
        };
        api.defaults = {};

        api.remove = function (key, attributes) {
            api(key, '', extend(attributes, {
                expires: -1
            }));
        };

        api.withConverter = init;

        return api;
    }

    return init(function () {});
}));

/**
 * Cookie Notice
  */
jQuery(document).ready(function ($) {
    /**
     * Cookie Policy Open
     */
    if (!Cookies.get('cookie_acceptance')) {
        $("#cookie-notice").slideDown();
    }

});

/**
 * Cookie Policy Close
 */
jQuery(document).on("click", "#cookie-notice .cookie-policy-agree", function () {
    jQuery(this).closest("#cookie-notice").slideUp();
    Cookies.set("cookie_acceptance", 'close', {expires: 186});
});

/********** DEFINE MAIN VARIABLES **********/
var _DJ = {
    space: " "
};
/********** END DEFINE MAIN VARIABLES **********/

/********** START MOBILE MENU **********/
var _DJ_MOBILE_MENU = {
    mobileContainer: ".header-mobile-menu-container",
    mobileItemsContainer: ".header-mobile-menu",
    mobileDiv: "#mobile-menu",
    mobileDivDrilldown: "#mobile-menu-drilldown",
    activeClass: "is-active",
    canvasDiv: "#mobile-menu-canvas",
    backText: '<li class="js-drilldown-back"><a>Back</a></li>',
    offCanvasContent: ".off-canvas-content",
    footerClass: "._footer",
    rowClass: ".vc_row",
    bodyMobileClass: "mobile-menu",
    open: function () {
        jQuery(_DJ_MOBILE_MENU.offCanvasContent + ',' + _DJ_MOBILE_MENU.footerClass + ',' + _DJ_MOBILE_MENU.rowClass).addClass("hide");
        jQuery("body").addClass(_DJ_MOBILE_MENU.bodyMobileClass);
        jQuery(_DJ_MOBILE_MENU.mobileContainer + _DJ.space + _DJ_MOBILE_MENU.mobileDiv).addClass(_DJ_MOBILE_MENU.activeClass);
    },
    close: function () {
        jQuery(_DJ_MOBILE_MENU.offCanvasContent + ',' + _DJ_MOBILE_MENU.footerClass + ',' + _DJ_MOBILE_MENU.rowClass).removeClass("hide");
        jQuery("body").removeClass(_DJ_MOBILE_MENU.bodyMobileClass);
        jQuery(_DJ_MOBILE_MENU.mobileContainer + _DJ.space + _DJ_MOBILE_MENU.mobileDiv).removeClass(_DJ_MOBILE_MENU.activeClass);
    },
    setBack: function (string) {
        var backText = '<a>' + string + '</a>';
        jQuery(".js-drilldown-back").html(backText);
    },
    buildDropDown: function (parentId, parentClass, addId, addClass) {
        //add hide on mobile class to the menu
        // Create the dropdown base
        jQuery("<select />", {id: addId, "class": addClass}).appendTo(parentClass);

        // Create default option "Go to..."
        jQuery("<option />", {
            "selected": "selected",
            "value": "",
            "text": "Go to..."
        }).appendTo('#' + addId);

        // Populate dropdown with menu items
        jQuery('#' + parentId + " a").each(function () {
            var el = jQuery(this);
            jQuery("<option />", {
                "value": el.attr("href"),
                "text": el.text()
            }).appendTo('#' + addId);
        });
    },
    init: function () {
        var history = [];
        var firstBack = false;
        jQuery(_DJ_MOBILE_MENU.mobileDivDrilldown).on("open.zf.drilldown", function (ev, $el) {
            _DJ_MOBILE_MENU.setBack($el.attr('back-text'));
            //store a history
            //reset history method
            if ($el.attr("level") === '0') {
                history = [];
                firstBack = false;
            }
            if ($el.attr("level") !== '0') {
            }
            history.push($el.attr('back-text'));
        });

        jQuery(_DJ_MOBILE_MENU.mobileDivDrilldown).on("hide.zf.drilldown", function (ev, $el) {
            if (!firstBack) {
                firstBack = true;
                history.pop();
            }
            var latestElement = history.pop();
            if (latestElement !== 'undefined' && typeof latestElement !== 'undefined') {
                _DJ_MOBILE_MENU.setBack(latestElement);
            } else {
                _DJ_MOBILE_MENU.setBack('Home');
            }
        });

        jQuery(_DJ_MOBILE_MENU.canvasDiv).on("opened.zf.offcanvas", function (ev, $el) {
            _DJ_MOBILE_MENU.open();
        });
        jQuery(_DJ_MOBILE_MENU.canvasDiv).on("closed.zf.offcanvas", function (ev, $el) {
            _DJ_MOBILE_MENU.close();
        });
    }
};
/********** END MOBILE MENU **********/

/********** START DESKTOP MENU **********/
var _DJ_DESKTOP_MENU = {
    headerBoxSpacing: "._header_box_spacing",
    headerBoxDiv: "._header_box_menu",
    headerBoxMenu: "._header_box_menu a",
    loadMenu: ".load_menu",
    menuActiveClass: "_header_box_menu_active",
    menuContainer: "._header_box_menu_container",
    headerBox: "._header",
    openData: "open",

    _slider: "._slider",

    open: function () {

    },
    close: function () {
        jQuery(_DJ_DESKTOP_MENU.loadMenu).removeClass(_DJ_DESKTOP_MENU.openData);
        jQuery(_DJ_DESKTOP_MENU.headerBoxMenu).removeClass(_DJ_DESKTOP_MENU.menuActiveClass);
    },
    init: function (string) {
        // jQuery(document).on("click touchend", document, function (obj) {
        //     // _DJ_DESKTOP_MENU.close();
        // });

        // jQuery(_DJ_DESKTOP_MENU.headerBoxSpacing).on("mouseover mouseenter click touched", document, function (obj) {
        //     // _DJ_DESKTOP_MENU.close();
        // });

        jQuery(document).on("touchend", _DJ_DESKTOP_MENU.headerBoxMenu, function (obj) {
            return false;
        });

        //open menu
        jQuery(_DJ_DESKTOP_MENU.headerBoxMenu).on("click touchend", function (obj) {
            // prevent default action
            obj.preventDefault();

            if(jQuery("." + jQuery(this).data(_DJ_DESKTOP_MENU.openData)).hasClass("open")){
                window.location.href = jQuery(this).attr("href");
            }

            jQuery(_DJ_DESKTOP_MENU.loadMenu).removeClass(_DJ_DESKTOP_MENU.openData);
            jQuery("." + jQuery(this).data(_DJ_DESKTOP_MENU.openData)).addClass(_DJ_DESKTOP_MENU.openData);

            if(!jQuery("." + jQuery(this).data(_DJ_DESKTOP_MENU.openData)).hasClass("load_menu")) {
                window.location.href = jQuery(this).attr("href");
            }

            // jQuery("." + jQuery(this).data(_DJ_DESKTOP_MENU.openData) + ' ' + menu_container).addClass("pullDown");

            jQuery(_DJ_DESKTOP_MENU.headerBoxMenu).removeClass(_DJ_DESKTOP_MENU.menuActiveClass);
            jQuery(this).addClass(_DJ_DESKTOP_MENU.menuActiveClass);
            _DJ_DESKTOP_MENU.open();
        });

        //close menu
        // jQuery(_DJ_DESKTOP_MENU.headerBox).on('mouseleave', function () {
        //     // jQuery(_DJ_DESKTOP_MENU.headerBox).mouseleave(function () {
        //     _DJ_DESKTOP_MENU.close();
        // });

        jQuery(document).on('click touchend', function (obj) {
            var objClass = obj.target.className;
            // jQuery(_DJ_DESKTOP_MENU.headerBox).mouseleave(function () {
            if(objClass!=='title _header_box_menu_active' && objClass!=='title _header_box_menu_selected _header_box_menu_active'){
                _DJ_DESKTOP_MENU.close();
            } else {
            }
        });

    }
};
/********** END DESKTOP MENU **********/

/**
 * Code initialization
 */
jQuery(function () {
    /** Mobile menu **/
    Foundation.Drilldown.defaults.backButton = _DJ_MOBILE_MENU.backText;
    _DJ_MOBILE_MENU.init();
    /** DESKTOP MENU **/
    _DJ_DESKTOP_MENU.init();
    /** BUILD DROPDOWNS **/
    //Generate submenu dropdown option

    // Populate dropdown with menu items
    jQuery(".secondary_menu").each(function (submenuNb, submenuObj) {
        jQuery(submenuObj).find('ul').each(function (ulNb, ulObj) {
            var uniqueId = jQuery(ulObj).attr("id");
            _DJ_MOBILE_MENU.buildDropDown(uniqueId, submenuObj, uniqueId + '_dropdown', '_dropdown_submenu_mobile change-submenu');
        });
    });
});

jQuery('._dj_slider_init').slick({
    centerMode: true,
    slidesToShow: 1
});

jQuery("._dj_slider_controls_left").on("click", function () {
    var dgSlideInit = jQuery(this).attr("slide-id");
    jQuery('#_dj_slider_' + dgSlideInit).slick('slickPrev');
});

jQuery("._dj_slider_controls_right").on("click", function () {
    var dgSlideInit = jQuery(this).attr("slide-id");
    jQuery('#_dj_slider_' + dgSlideInit).slick('slickNext');
});

jQuery(document).on("change", ".change-submenu", function () {
    window.location.href = jQuery(this).val();
});

jQuery(function () {
    jQuery("._djProgressBar > span").each(function () {
        jQuery(this)
            .data("origWidth", jQuery(this).width())
            .width(0)
            .animate({
                width: jQuery(this).data("origWidth")
            }, 1200);
    });
});

jQuery('._numberWidget ._numberWidgetCounter').each(function () {
    jQuery(this).prop('Counter', 0).animate({
        Counter: jQuery(this).attr("counter")
    }, {
        duration: 2500,
        easing: 'swing',
        step: function (now) {
            jQuery(this).text(Math.ceil(now));
        }
    });
});

function masonryLoad() {
    jQuery("._news_grid").masonry({
        itemSelector: "._news_item",
        columnWidth: '.grid-sizer',
        gutter: 20,
        isFitWidth: !0
    });
}
function masonryDestroy() {
    jQuery("._news_grid").masonry('destroy');
}
window.onresize = function () {
    masonryDestroy();
    masonryLoad();
};
window.onload = function () {
    masonryLoad();
};

jQuery(document).on("click", ".quick-search", function () {
    var form = jQuery(this).parents('form:first');
    form.submit();
});

// Scroll Reveal
if (jQuery('.scrollReveal').length) {
    var fooReveal = {
        delay: 250,
        distance: '0px',
        easing: 'ease-in-out',
        scale: 1.1
    };
    window.sr = new ScrollReveal();
    sr.reveal('.scrollReveal', fooReveal);
}


jQuery(function () {
    // browser window scroll (in pixels) after which the "back to top" link is shown
    var offset = 300,
        //browser window scroll (in pixels) after which the "back to top" link opacity is reduced
        offset_opacity = 1200,
        //duration of the top scrolling animation (in ms)
        scroll_top_duration = 700,
        //grab the "back to top" link
        $back_to_top = jQuery('.cd-top');

    //hide or show the "back to top" link
    jQuery(window).scroll(function(){
        if(jQuery(this).scrollTop() > offset) {
            $back_to_top.addClass('cd-is-visible');
        } else {
            $back_to_top.removeClass('cd-is-visible cd-fade-out');
        }
        if( jQuery(this).scrollTop() > offset_opacity ) {
            $back_to_top.addClass('cd-fade-out');
        }
    });
    //smooth scroll to top
    $back_to_top.on('click', function(event){
        event.preventDefault();
        jQuery('body,html').animate({
                scrollTop: 0 ,
            }, scroll_top_duration
        );
    });

});